var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoonStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_753_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1L9.3089 1.61779C9.44164 1.88328 9.50801 2.01603 9.59668 2.13106C9.67536 2.23313 9.76687 2.32464 9.86894 2.40332C9.98397 2.49199 10.1167 2.55836 10.3822 2.6911L11 3L10.3822 3.3089C10.1167 3.44164 9.98397 3.50801 9.86894 3.59668C9.76687 3.67536 9.67536 3.76687 9.59668 3.86894C9.50801 3.98397 9.44164 4.11672 9.3089 4.38221L9 5L8.6911 4.38221C8.55836 4.11672 8.49199 3.98397 8.40332 3.86894C8.32464 3.76687 8.23313 3.67536 8.13106 3.59668C8.01603 3.50801 7.88328 3.44164 7.61779 3.3089L7 3L7.61779 2.6911C7.88328 2.55836 8.01603 2.49199 8.13106 2.40332C8.23313 2.32464 8.32464 2.23313 8.40332 2.13106C8.49199 2.01603 8.55836 1.88328 8.6911 1.61779L9 1Z",
    stroke: "#5925DC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.69465C9.84449 7.8445 8.60727 8.61975 7.18897 8.61975C5.08554 8.61975 3.38037 6.91459 3.38037 4.81116C3.38037 3.39277 4.15574 2.15547 5.30575 1.5C2.8899 1.72906 1 3.76346 1 6.23927C1 8.86855 3.13146 11 5.76075 11C8.23644 11 10.2708 9.11031 10.5 6.69465Z",
    stroke: "#5925DC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_753_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonStar);
export default __webpack_public_path__ + "static/media/moon-star.166d8679ce73254beecc1663b54e39df.svg";
export { ForwardRef as ReactComponent };